import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import InvitationPage from "./pages/InvitationPage";
import AdminLogin from "./pages/AdminLogin";
import AdminCheckIn from "./pages/AdminCheckIn";
import AdminDashboard from "./pages/AdminDashboard";
import AdminGetAllGuestPage from "./pages/AdminGetAllGuestPage";
import RequireAuth from "./auth/RequireAuth";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default route -> go to admin login */}
        <Route path="/" element={<Navigate to="/admin/login" replace />} />

        {/* Public routes */}
        <Route path="/invitation/:qrCode" element={<InvitationPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        {/* Protected routes */}
        <Route
          path="/admin/dashboard"
          element={
            <RequireAuth>
              <AdminDashboard />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/checkin"
          element={
            <RequireAuth>
              <AdminCheckIn />
            </RequireAuth>
          }
        />

        <Route
          path="/admin/guests"
          element={
            <RequireAuth>
              <AdminGetAllGuestPage />
            </RequireAuth>
          }
        />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}


